 export class Utils {
    public static loadExternalJs(url: string): void {
        const script = document.createElement('script');
        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
     }

     public static changeFavicon(faviconHref: string): void {
         const favicons = document.querySelectorAll('link[href*="favicon"]');
         const head = document.getElementsByTagName('head')[0];

         for (let i = 0; i < favicons.length; i++) {
             head.removeChild(favicons[i]);
         }

         const newFavicon = document.createElement('link');
         newFavicon.href = faviconHref;
         newFavicon.type = 'image/x-icon';
         newFavicon.rel = 'shortcut icon';

         head.appendChild(newFavicon);
     }

     public static changePageTitle(title: string): void {
         document.getElementsByTagName('title')[0].text = title;
     }

     public static isLiveEnvironment(): boolean {
         return window.location.hostname === 'api.deal-track.com';
     }

     public static isUatEnvironment(): boolean {
         return window.location.hostname === 'api-uat.deal-track.com';
     }
}
